import { Outlet } from 'react-router-dom';
import ResponsiveNav from '../ResponsiveNav';
import { useSwipeBack } from '../../hooks/useSwipeBack';

const MobileLayout = ({ user, onLogout, children }) => {
  // Enable swipe-to-go-back gesture
  useSwipeBack(true);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Responsive Navigation - Shows as top bar on desktop, bottom bar on mobile */}
      {user && onLogout && <ResponsiveNav user={user} onLogout={onLogout} />}
      
      {/* Main content area with padding for navigation */}
      <main className="flex-1 overflow-auto md:pt-0 pb-16 md:pb-0">
        {children || <Outlet context={{ user, onLogout }} />}
      </main>
    </div>
  );
};

export default MobileLayout;

